module.exports = __webpack_public_path__ + "media/images/lb/516-318ec28ed17372d7f7742b678b25a272.svg";